import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/detection-report";
const API_PATH_EXCEL = ConstantList.API_ENPOINT + "/api/etb/download-file";

export const pagingReport01s = (searchObject) => {
  var url = API_PATH + "/paging-detection-reports";
  return axios.post(url, searchObject);
};

export const getReport01 = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createReport01 = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editReport01 = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteReport01 = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const saveReportLevelProvince = (obj) => {
  let url = API_PATH + "/save-report-level-province";
  return axios.post(url, obj);
};

export const lockReport = (id) => {
  let url = API_PATH + "/lock-report/" + id;
  return axios.post(url);
};

export const unLockReport = (id) => {
  let url = API_PATH + "/un-lock-report/" + id;
  return axios.post(url);
};

export const lockReportBySearch = (searchObject) => {
  var url = API_PATH + "/lock-report-by-search";
  return axios.post(url, searchObject);
};

export const unLockReportBySearch = (searchObject) => {
  var url = API_PATH + "/un-lock-report-by-search";
  return axios.post(url, searchObject);
};

export const importDetectionReportLevelProvince = (file) => {
  const url = API_PATH_EXCEL + "/importDetectionReportLevelProvince";
  let formData = new FormData();
  formData.append("uploadfile", file); //Lưu ý tên 'uploadfile' phải trùng với tham số bên Server side
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
}

export const exportimportDetectionReportLevelProvince = (obj) => {
  let url = API_PATH_EXCEL + "/exportimportDetectionReportLevelProvince";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}